import Typeahead from 'corejs-typeahead/dist/typeahead.bundle';
import N2StylesModal from './N2StylesModal'
import ShareForm from './ShareForm'

export default class ShareArticleHandler {
  constructor() {
    this.resetSelf()
  }

  init() {
    this.listen()
  }

  unload() {
    $('.js-area-director-name').typeahead('destroy')
  }

  listen() {
    this.setupTypeAhead()
    N2.handle("click", '.js-share-article', (evt) => {
      new N2StylesModal(".js-share-modal")

      this.resetSelf()
      this.removeFormMessages()
      this.emptyTerritories()
      this.setupTypeAheadValue('')
    })

    N2.handle("submit", '.js-share-article-form', (evt) => {
      evt.preventDefault()

      this.submitShareSearch($(evt.currentTarget));
    })
  }

  submitShareSearch($form) {
    let form = new N2Styles.manualForm($form.attr('action'))
    form.addInput('name', this.getTypeaheadValue())
    form.setRootParam('area_directors')
    form.form.attr('method', 'GET');

    form.sync({
      success: this.onSuccess,
      error: this.onError,
      context: this
    });
  }

  onSuccess(resp){
    this.removeFormMessages()
    this.emptyTerritories()
    if (resp === null) {
      this.resetSelf()
      this.addADError("Invalid Area Director")
    } else {
      this.user = resp.user
      this.territories = resp.territories
      this.showTerritories()
      this.shareForm = this.setupShareForm()
    }
  }

  sendForm(url) {
    $.each($('.js-chosen-territory:checked'), (i, ele) => {
      let selected = $.grep(this.territories, (a) => { return a.id == ele.id; })[0];
      this.chosenTerritories.push(selected)
    })

    if (this.validateForm()) {
      this.shareForm.setUrl(url)
      $.each(this.chosenTerritories, (i, terr) => {
        this.shareForm.addInput('article_jobs[territory_ids][]', terr.id)
      });
      this.shareForm.post()
    } else {
      if (this.user === null) {
        this.addADError("Please enter a valid Area Director Name")
      } else {
        this.addTerritoryError("You must select atleast one territory.")
      }
    }
  }

  setupShareForm() {
    let shareForm = new N2Styles.manualForm()
    shareForm.addInput('article_jobs[user_id]', this.user.id)
    shareForm.form.attr('method', 'POST');

    N2.handle('change', '.js-chosen-territory', (evt) => {
      if ( $('.js-chosen-territory:checked').length > 0 && $('.js-more-territories').hasClass('checkbox--invalid')) {
        this.removeTerritoryError()
      }
    })


    return shareForm
  }

  onError(resp){
    this.resetSelf()
    this.addFormError("Something has gone wrong with. Please check back soon.")
  }

  addADError(msg){
    $('.js-area-director-name').addClass('invalid')
    $('.js-share-article-form').after(`<small class='invalid red-text js-error-text'>${msg}</small>`)
  }

  addTerritoryError(msg) {
    $('.js-more-territories').addClass('checkbox--invalid')
    $('.js-more-territories').after(`<small class='invalid red-text js-error-text'>${msg}</small>`)
  }

  removeFormMessages() {
    $('.js-area-director-name').removeClass('invalid')
    $('.js-error-text').remove()
  }

  removeTerritoryError() {
    $('.js-more-territories').removeClass('checkbox--invalid')
    $('.js-error-text').remove()
  }

  emptyTerritories() {
    $('.js-more-territories').empty()
    $('.js-choose-label').remove()
    this.removeTerritoryError()
  }

  validateForm() {
    return (this.user !== null && this.territories !== null && this.shareForm !== null && this.chosenTerritories.length > 0)
  }

  showTerritories() {
    $('.js-more-territories').before("<p class='pt-2 js-choose-label'>Choose Territory(s)</p>")
    $.each(this.territories, (i, terr) => {
      $('.js-more-territories').append(
        `<fieldset class="form-group p-1 m-0">
          <input type="checkbox" id="${terr.id}" class="filled-in js-chosen-territory"></input>
          <label for="${terr.id}" class="fs-small grey-text text-darken-3">${terr.name}</label>
        </fieldset>`
      )
    })
  }

  resetSelf() {
    this.shareForm = null
    this.user = null
    this.territories = null
    this.chosenTerritories = []
  }

  setupTypeAhead() {
    $('.js-area-director-name').typeahead({
      minLength: 4,
      highlight: true
    }, {
      source: (query, syncResults, asyncResults) => {
        $.get('/area_directors/autocomplete?search=' + query, function(data) {
          asyncResults(data)
        })
      },
      displayKey: 'full_name'
    }).bind('typeahead:select', (evt, suggestion) => {
      let $form = $($(evt.currentTarget).closest('form'));
      this.submitShareSearch($form);
    });
  }

  setupTypeAheadValue(val) {
    $($('.js-area-director-name')[1]).val(val)
  }

  getTypeaheadValue() {
    return $($('.js-area-director-name')[1]).val()
  }
}
